module.exports = __webpack_public_path__ + "static/img/4.da11c2e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/4.png
// module id = C5su
// module chunks = 1